import { pickSharedFilterSearch } from '../../../lib/filter-config';

/**
 * Builds the `/map` navigation search object for the catalog's inline "Mapa"
 * toolbar icon — carries the shared filter dimensions (via
 * `pickSharedFilterSearch`) AND `addToOfferId` (catalog-column-filter-parity:
 * "Catalog↔map navigation inside offer context preserves both", mirroring
 * the sidebar "Mapa" link's `sharedFilterSearch` in `app-shell.tsx`, which
 * this inline toolbar button previously bypassed — CU-86cb1nq7h regression:
 * the toolbar button navigated to a bare `/map` with no search params at
 * all, silently dropping both the active filters and the offer-add context).
 *
 * `pickSharedFilterSearch` now carries over every spatial filter dimension —
 * the shared fields, material/multiformat/tags/address/notes/roadNumber, all
 * numeric ranges, `noPhoto`, and the availability date range
 * (map-catalog-filter-parity). Only `importJobId`, `exclude`, and `search`
 * (map has its own independent search box) are still dropped, by
 * `pickSharedFilterSearch` itself — unchanged by this helper.
 */
export function buildMapNavigationSearch(
  routeSearch: Record<string, unknown>,
): Record<string, unknown> {
  const shared = pickSharedFilterSearch(routeSearch);
  const addToOfferId =
    typeof routeSearch['addToOfferId'] === 'string' ? routeSearch['addToOfferId'] : undefined;
  return addToOfferId ? { ...shared, addToOfferId } : shared;
}
